import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useOption } from '@react-aria/listbox';
import PropTypes from 'prop-types';
import React__default, { useEffect } from 'react';
import { useSwanListboxListContext } from './listbox-list.context.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var propTypes = {
  /**
  * Whether or not the option is disabled.
  */
  disabled: PropTypes.bool,

  /**
  * Whether or not the option has a thumbnail.
  */
  withThumbnail: PropTypes.bool,

  /**
  * The contents to render inside the ListboxButton. Can include JSX
  */
  label: PropTypes.node,

  /**
  * The option's human-readable string. Required if using JSX inside of an option
  */
  textValue: PropTypes.string
};
var propKeysToRemove = [].concat(_toConsumableArray(Object.keys(propTypes)), ['textValue']);
/**
 * ListboxOptionInternal is the internal component for rendering an item
 *
 * The public ListboxOption is only used for the ListboxList to parse the children and store in state
 */

var ListboxOptionInternal = function ListboxOptionInternal(_ref) {
  var item = _ref.item,
      state = _ref.state;
  var ref = React__default.useRef(null);

  var _item_props; // get props from ListboxOption
  // if disabled is not given here, it can also be supplied as part of `disabledKeys` on the root component


  var _ref2 = (_item_props = item.props) !== null && _item_props !== void 0 ? _item_props : {},
      disabled = _ref2.disabled;

  var _useOption = useOption(item, state, ref),
      optionProps = _useOption.optionProps,
      isFocused = _useOption.isFocused;

  var _useSwanListboxListCo = useSwanListboxListContext(),
      setDisabledKeys = _useSwanListboxListCo.setDisabledKeys; // if the disabled prop is set on the option, the state needs to be passed up the tree to the root component


  useEffect(function () {
    if (disabled !== undefined) {
      var key = item.key;
      setDisabledKeys(function (s) {
        var newState = new Set(s);

        if (disabled) {
          newState.add(key);
        } else {
          newState.delete(key);
        }

        return newState;
      });
    }
  }, [disabled, setDisabledKeys, item.key]);
  var classes = new Set(['swan-listbox-option']);
  if (item.props.withThumbnail) classes.add('swan-listbox-option-with-thumbnail');
  if (isFocused) classes.add('swan-listbox-option-focused');
  return /*#__PURE__*/React__default.createElement(RenderComp, {
    root: "li",
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    props: _object_spread({}, item.props, optionProps),
    classNames: classes
  }, item.rendered);
};

export { ListboxOptionInternal, propTypes };